import React  from 'react';
import {Button} from '@mui/material/';
import Icon from '@mui/material/Icon';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.spacing(1),
        backgroundColor:'#205690',
        color:'white',
        '&:hover':{
            backgroundColor:'rgba(17, 82, 147, 0.8)',
        }
    },
    icon:{
        marginRight: theme.spacing(1),
    }
}));

export default function BottonDeAtras(props) {
    const classes = useStyles();

    return (
        <Button className={classes.button} label={props.tooltip} onClick={props.onClick} disabled={props.disabled}  variant="contained" >
            <Icon className={classes.icon} >{props.icon}</Icon>
            {props.tooltip}
        </Button>
    )
}
